/**
 * Basic functionality every type of wizard step needs to provide
 *
 * @author Marc Arndt
 */
var WizardStep = (function () {
    function WizardStep() {
    }
    return WizardStep;
}());
export { WizardStep };
//# sourceMappingURL=wizard-step.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-archwizard/dist/components/util/wizard-step.interface.js
// module id = 58
// module chunks = 4